import React from 'react';
import Hero from '../../components/layout/Hero';
import Introduction from '../../sections/LandingPage/Introduction';
import BuscaAbogado from '../../sections/LandingPage/BuscaAbogado';
import EspecialidadesInfo from '../../sections/LandingPage/EspecialidadesInfo';
import ConsultaExpress from '../../sections/LandingPage/ConsultaExpress';
import VisualRest from '../../sections/LandingPage/VisualRest';
import BlogSection from '../../sections/LandingPage/BlogSection';
import FaqSection from '../../sections/LandingPage/FaqSection';

export default function LandingPage() {
  return (
    <div>
      <Hero />
      <Introduction />
      <BuscaAbogado />
      <EspecialidadesInfo />
      <ConsultaExpress />
      <VisualRest />
      <BlogSection />
      <FaqSection />
    </div>
  );
}
